import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/images/modelIcon_mx.png'
import _imports_1 from '@/assets/images/modelIcon_dy.png'
import _imports_2 from '@/assets/images/modelIcon_qj.png'
import _imports_3 from '@/assets/images/modelIcon_gs.png'


const _hoisted_1 = { class: "scene-container" }
const _hoisted_2 = {
  key: 0,
  class: "uav-contaainer-top"
}
const _hoisted_3 = { class: "uav-img-container" }
const _hoisted_4 = { class: "inner" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "uav-name" }
const _hoisted_8 = {
  key: 1,
  class: "uav-contaainer-bottom"
}
const _hoisted_9 = { class: "carousel-container" }
const _hoisted_10 = { class: "inner" }
const _hoisted_11 = { class: "content" }
const _hoisted_12 = { class: "image-inner" }
const _hoisted_13 = { class: "content-container" }
const _hoisted_14 = { class: "carouel-inne-container" }
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  key: 0,
  class: "model-icon",
  src: _imports_0,
  alt: ""
}
const _hoisted_17 = {
  key: 1,
  class: "model-icon",
  src: _imports_1,
  alt: ""
}
const _hoisted_18 = {
  key: 2,
  class: "model-icon",
  src: _imports_2,
  alt: ""
}
const _hoisted_19 = {
  key: 3,
  class: "model-icon",
  src: _imports_3,
  alt: ""
}
const _hoisted_20 = { class: "btn-group-container" }
const _hoisted_21 = { class: "uav-name" }
const _hoisted_22 = {
  key: 2,
  class: "uav-contaainer-bottom"
}
const _hoisted_23 = { class: "uav-info-container" }
const _hoisted_24 = { class: "info-inner" }
const _hoisted_25 = { class: "content" }
const _hoisted_26 = { class: "value" }
const _hoisted_27 = { class: "uav-info-container" }
const _hoisted_28 = { class: "info-inner" }
const _hoisted_29 = { class: "content" }
const _hoisted_30 = { class: "value" }
const _hoisted_31 = { class: "uav-info-container switch-model-container" }
const _hoisted_32 = { class: "info-inner" }
const _hoisted_33 = {
  key: 0,
  class: "switch-model-container"
}
const _hoisted_34 = { class: "switch-inner" }
const _hoisted_35 = { class: "siwtch-item" }
const _hoisted_36 = ["src"]
const _hoisted_37 = { class: "model-name" }
const _hoisted_38 = ["id"]
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["id"]
const _hoisted_41 = ["onClick"]
const _hoisted_42 = { class: "model-body" }
const _hoisted_43 = { class: "content-box" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { class: "img-box" }
const _hoisted_46 = ["src"]
const _hoisted_47 = { class: "uav-name" }
const _hoisted_48 = { class: "model-footer" }
const _hoisted_49 = { class: "scene-selection-content" }
const _hoisted_50 = { class: "scene-list-container" }
const _hoisted_51 = ["onClick"]
const _hoisted_52 = ["src"]
const _hoisted_53 = {
  key: 0,
  class: "model-icon",
  src: _imports_0,
  alt: ""
}
const _hoisted_54 = {
  key: 1,
  class: "model-icon",
  src: _imports_1,
  alt: ""
}
const _hoisted_55 = {
  key: 2,
  class: "model-icon",
  src: _imports_2,
  alt: ""
}
const _hoisted_56 = {
  key: 3,
  class: "model-icon",
  src: _imports_3,
  alt: ""
}
const _hoisted_57 = { class: "scene-item-title" }
const _hoisted_58 = { class: "model-footer" }

import {ref, reactive, onMounted, onBeforeUnmount, onBeforeMount, computed, onUnmounted, getCurrentInstance,watch} from 'vue'
import {useStore} from 'vuex'
import {useRouter, useRoute} from 'vue-router'
import { getSceneCategory, getSceneUavList, getExamSceneInfoTab,createTraining,getSecondaryPageData,getUserTrainingSetting,saveUserTrainingSetting } from '@/service'
import {$enum, $config} from '@/global/index'
import {NCarousel} from 'naive-ui'
import {StationItem,ICard} from '@/types/baseInterFace'
import StudyPlan from '@/views/studyPlan/index.vue'
import {createRandomWind,getWindDirection} from '@/utils/index'

const cardDesignWidth = 450;
const cardDesignHeight = 654;

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  showStudyPlanModal: {
    type: Boolean,
    default: false
  }
},
  emits: ["onGetActionButtons", "onCloseStudyPlanModal"],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit
const { proxy } = getCurrentInstance()!
const store = useStore()
const router = useRouter()
const route = useRoute()
const designSize = {w: 1920, h: 1080}
const cardDisgn = {w: 240,h: 654}
const cardStyle = ref({width: '240px', height: '654px'});
const cardBoxStyle = ref({"min-width":"816px"});
const currentModelIndex = ref(0)
const modelList = ref([])
const modelIconMap: Record<number, string> = {
  1: require('@/assets/images/swich_model.png'),
  2: require('@/assets/images/switch_dianyun.png'),
  8: require('@/assets/images/switch_sheying.png'),
  9: require('@/assets/images/switch_gaosi.png'),
}
const showModel = ref(false);
const uavDataList = ref([])
const currentUavData = ref({})
const currentUavId = ref(null)
const actionButtonList = ref([])
const confirmLoading = ref(false)
const currentModelId = ref(null)

const showSceneSelectionModal = ref(false)
const currentCardItem = ref<ICard>()
const sceneTypeId = ref(store.state.persistence.breadcrumb[store.state.persistence.breadcrumb.length-1].id)
const stationList = ref<StationItem[]>([])
const examSceneInfo = ref<ICard>()
const stationDataList = ref<any[]>([])
const currentStationIndex = ref(-1)

const currentStatsionData = ref({})
const courseTypeId = ref(store.state.persistence.breadcrumb[store.state.persistence.breadcrumb.length-1].courseTypeId)
const scale = computed(() => {
  return Math.min(
    window.innerWidth / designSize.w,
    window.innerHeight / designSize.h
  );
});

const currentStationId = computed(()=>{
  return store.state.persistence.userTrainSettingInfo.currentStationId || null
})

watch(()=>currentModelIndex.value, (newVal, oldVal) => {
  store.commit('persistence/setCurrentResourceId', modelList.value[newVal]?.id);
})

const cardsList = ref<ICard[]>([])

const setCardDimensions = () => {
  cardStyle.value = {
    width: `${cardDesignWidth * scale.value}px`,
    height: `${cardDesignHeight * scale.value}px`,
  };
  cardBoxStyle.value = {
    "min-width": `${((cardDesignWidth + 32) * 3) * scale.value }px`,
  }
};

//获取用户训练数据设置
async function getUserTrainSetting(){
  let param = {
    "userId": store.state.persistence.userInfo.userId,
    "tenantId": store.state.persistence.currentTenantId,
    "sceneTypeId": sceneTypeId.value,
  }
  let {code,data} = await getUserTrainingSetting(param)
  if(code == $enum.EnumResult.SUCCESS){
    let {uavSpId, resourceTypeId, windDirection, windPower, sightHeight, sightDist, sightFov, changeFovDist, lightDirection, supportViewport,shadowEnable,stationId,distance,usedTemplateId,guideLineIds,enableGuide} = data || {}
    if(uavSpId){
      currentUavId.value = uavSpId
      currentUavData.value = uavDataList.value.find(item => item.id == uavSpId) || {}
    }else{
      currentUavId.value = uavDataList.value[0]?.id || null
      currentUavData.value = uavDataList.value[0] || {}
    }
    if(uavDataList.value.length == 0){
      store.commit('persistence/clearCurrentUavInfo');
    }else{
      setCurrentUavInfo()
    }

    if(courseTypeId.value == 3){
      //输电
      if(resourceTypeId){
      // 资源类型（1:模型；2:点云；3:全景；4:点位；5:路网; 6:其他; 7:模型库; 8:倾斜摄影;9:高斯）
        currentModelId.value = resourceTypeId
        currentModelIndex.value = modelList.value.findIndex(item => item.id == resourceTypeId) || 0
      }else{
        currentModelId.value = modelList.value[0]?.id || null
        currentModelIndex.value = Array.isArray(modelList.value) && modelList.value.length ? 0 : 0
      }
    }

    let currentStationId = null
    if(courseTypeId.value == 1){
      //caac
      if(stationDataList.value.length > 0){
        if(stationId){
          currentStatsionData.value = stationDataList.value.find(item => item.stationId == stationId) || {}
          currentStationId = stationId
        }else{
          currentStatsionData.value = stationDataList.value[0] || {}
          currentStationId = stationDataList.value[0]?.stationId
        }
        currentModelId.value = currentStatsionData.value?.resourceType
      }
    }
    store.commit('persistence/setUserTrainingSetting', {uavSpId:currentUavId.value, resourceTypeId:currentModelId.value, currentStationId:currentStationId, windDirection, windPower, sightHeight, sightDist, sightFov, changeFovDist, lightDirection, supportViewport,shadowEnable,distance,usedTemplateId,guideLineIds,enableGuide})
  }
}

async function getPageData(){
  cardsList.value = []
  uavDataList.value = []
  modelList.value = []
  stationDataList.value = []
  actionButtonList.value = []
  let param = {
    "userId": store.state.persistence.userInfo.userId,
    "tenantId": store.state.persistence.currentTenantId,
    "sceneTypeId": sceneTypeId.value,
  }
  const {code, data, message} = await getSecondaryPageData(param);
  if(code !== $enum.EnumResult.SUCCESS){
    proxy?.vknMessage.error(message)
    return
  }
  const {sceneCategoryTabVoList,teachingButtonVoList,sceneUavTypeVOList,resourceTypeVoList, stationDataVoList} = data || {};

  //卡片数据
  if(Array.isArray(sceneCategoryTabVoList) && sceneCategoryTabVoList.length){
    let arr = []
    sceneCategoryTabVoList.forEach(item => {
        arr.push({
          ...item,
          id: item.id,
          title: item?.sceneCategoryName,
          description: item.typeDescription,
          userAvailable: true,
          pictureUrl: $config.FILE_ROOT_PATH + item.pictureUrl,
          isLocked: item.isLocked
        })
      });
      cardsList.value = arr
  }

  //无人机数据
  if(Array.isArray(sceneUavTypeVOList) && sceneUavTypeVOList.length){
    uavDataList.value = sceneUavTypeVOList;
  }

  //模型类型列表
  if(Array.isArray(resourceTypeVoList) && resourceTypeVoList.length){
    let arr = []
    resourceTypeVoList.forEach((item,index)=>{
      if(item.typeId != 9 || (window.crossOriginIsolated && window.location.protocol.includes("https"))){
        arr.push({
          name: item.typeName,
          id: item.typeId,
          icon: modelIconMap[item.typeId] || ''
        })
      }
    })
    modelList.value = arr;
  }

  //操作按钮
  if (Array.isArray(teachingButtonVoList) && teachingButtonVoList.length) {
    if(window.location.protocol.includes("https")){
      emit('onGetActionButtons', teachingButtonVoList)
    }else{
      let arr:any[] = []
      teachingButtonVoList.forEach(item => {
        if(!('videoUrl' in item)){
          arr.push(item)
        }
      })
      emit('onGetActionButtons', arr)
    }
  }

  //场景列表
  if(Array.isArray(stationDataVoList) && stationDataVoList.length){
    stationDataList.value = stationDataVoList
  }
  getUserTrainSetting()
}

//更新store中当前机型信息
function setCurrentUavInfo() {
  let info = currentUavData.value as any;
  store.commit('persistence/setCurrentUavInfo', {
    ...store.state.persistence.currentUavInfo,
    uavId:info?.id,
    flyTime:info?.flyTime,
    maxZoom:info?.maxZoom,
    maxHolderPitch:info?.maxHolderPitchRotation,
    minHolderPitch:info?.minHolderPitchRotation,
  });
}

async function getExamSceneInfo(){
  let param = {
    "userId": store.state.persistence.userInfo.userId,
    "tenantId": store.state.persistence.currentTenantId,
    "sceneTypeId": sceneTypeId.value,
  }
  const {code, data, message} = await getExamSceneInfoTab(param) as any;
  if(code == $enum.EnumResult.SUCCESS){
    if(data && Object.keys(data).length > 0){
       enterFlightPage(data)
    }else{
      proxy?.vknMessage.error('场景信息为空')
    }
  }else{
    proxy?.vknMessage.error('获取场景信息失败！')
  }
}

const enterFlightPage = async (cardItem:ICard | undefined)=>{
  if(!cardItem) return
  let airLineId = null
  let sceneImageUrl = null
  let nestId = null
  let resourceFileList = []
  let stationId = null
  if(courseTypeId.value == $enum.CourseTypeEnum.CAAC多旋翼){
    //caac
    airLineId = currentStatsionData.value?.airLineId
    sceneImageUrl = currentStatsionData.value?.scenePictureUrl
    nestId = currentStatsionData.value?.uavNestId
    resourceFileList = currentStatsionData.value?.resourceFileList
    stationId = currentStatsionData.value?.stationId
  }
  if(courseTypeId.value == $enum.CourseTypeEnum.电力巡检){
    //输电模式
    airLineId = cardItem?.stationList[0]?.airLineId
    sceneImageUrl = cardItem?.stationList[0]?.scenePictureUrl
    nestId = cardItem?.stationList[0]?.uavNestId
    resourceFileList = cardItem?.stationList[0]?.resourceFileList
    stationId = cardItem?.stationList[0]?.stationId
  }
  let params = {
    userId:store.state.persistence.userInfo.userId,
    sceneId:cardItem?.id,
    uavSpecificationId:store.state.persistence.currentUavInfo.uavId,
    airLineId: airLineId,
    windPower:store.state.persistence.userTrainSettingInfo.windPower,
    windDirection:store.state.persistence.userTrainSettingInfo.windDirection,
    stationId
  }
  if(courseTypeId.value == $enum.CourseTypeEnum.CAAC多旋翼 && cardItem.sceneCategoryId == $enum.SceneCategoryEnum.模拟考核){
    let direction = createRandomWind().direction
    store.commit('persistence/setExamWindDirection', direction)
    params.windDirection = getWindDirection(direction)
    params.windPower = null
  }
  const res = await createTraining(params);
  if(res.code != $enum.EnumResult.SUCCESS){
    proxy?.vknMessage.error('生成训练数据失败！')
    return
  }
  const trainData = res.data;
  const {trainingId} = trainData as any || {};
  store.commit('persistence/setCurrentUavInfo', {
    ...store.state.persistence.currentUavInfo,
    nestId,
    trainingId,
    heightLimit:cardItem?.heightLimit,
    parentName:'考核',
    sceneImageUrl,
    sceneInfo:cardItem,
    resourceFileList,
    windSpeedIndex:'',
    windDirectionIndex:''
  });
  store.commit("persistence/setStationId", stationId);
  if(cardItem.courseTypeId == 1){
    router.push('/flight/exam')
  }else{
    router.push('/flight/transmit')
  }
}

 async function handleConfirmScene(){
  window?.playClick()
  if(stationDataList.value[currentStationIndex.value]?.stationId == currentStatsionData.value?.stationId){
    showSceneSelectionModal.value = false;
    return;
  }
  let param = {
    "userId": store.state.persistence.userInfo.userId,
    "tenantId": store.state.persistence.currentTenantId,
    "sceneTypeId": sceneTypeId.value,
    "stationId":stationDataList.value[currentStationIndex.value]?.stationId,
    "resourceTypeId":stationDataList.value[currentStationIndex.value]?.resourceType
  }
  confirmLoading.value = true
  window?.playClick()
  let {code , data, message} = await saveUserTrainingSetting(param)
  confirmLoading.value = false
  if(code !== $enum.EnumResult.SUCCESS || !data){
    proxy?.vknMessage.error(message || '保存失败')
    return
  }
  store.commit('persistence/setUserTrainingSetting', {
    ...store.state.persistence.userTrainSettingInfo,
    currentStationId:stationDataList.value[currentStationIndex.value]?.stationId,
    resourceTypeId:stationDataList.value[currentStationIndex.value]?.resourceType
  });
  currentStatsionData.value = stationDataList.value[currentStationIndex.value] || {};
  showSceneSelectionModal.value = false;
}

const handleClick = (card:ICard) => {
  if(card?.id == $enum.SceneCategoryEnum.科目训练 || card?.id == $enum.SceneCategoryEnum.通关测试){
    const arr = [...store.state.persistence.breadcrumb]
    arr[arr.length-1].active = false;
    arr.push({currentPage:3, path:'/thirdScene',name:card.title,active:true,id:card.id})
    store.commit('persistence/setBreadcrumb',arr);
    return;
  }
  getExamSceneInfo()
}

const handleClickSwitch = ()=>{
  window?.playClick()
  showModel.value = true
}

const handleSwitchScene = ()=>{
  window?.playClick()
  currentStationIndex.value = stationDataList.value.findIndex(item => item.stationId == currentStatsionData.value?.stationId) || 0
  showSceneSelectionModal.value = true
}

const handleClickUav = (id:string)=>{
  window?.playClick()
  currentUavId.value = id
}

function handleCancle(){
  window?.playClick()
  showModel.value = false;
}

function handleClose(){
  window?.playClick()
  showModel.value = false;
}

async function handleConfirm(){
  window?.playClick()
  let param = {
    "userId": store.state.persistence.userInfo.userId,
    "tenantId": store.state.persistence.currentTenantId,
    "sceneTypeId": sceneTypeId.value,
    "uavSpId":currentUavId.value
  }
  confirmLoading.value = true
  window?.playClick()
  let {code , data, message} = await saveUserTrainingSetting(param)
  confirmLoading.value = false
  if(code !== $enum.EnumResult.SUCCESS || !data){
    proxy?.vknMessage.error(message || '保存失败')
    return
  }
  store.commit('persistence/setUserTrainingSetting', {
    ...store.state.persistence.userTrainSettingInfo,
    uavSpId:currentUavId.value,
  });
  currentUavData.value = uavDataList.value.find(item=>item.id == currentUavId.value) || {};
  setCurrentUavInfo()
  showModel.value = false;
}

// 更新场景
function handleUpdatScene(currentIndex: number, lastIndex: number):void{
  currentModelIndex.value = currentIndex;
}

// 切换模型
function handleSwitchModel(type:'prev'|'next',fn:()=>void){
  if((type == 'prev' && currentModelIndex.value == 0) || (type == 'next' && currentModelIndex.value == modelList.value.length - 1)){
    return
  }
  window?.playClick()
  fn()
}

function handleCloseStudy(){
  window?.playClick()
  emit('onCloseStudyPlanModal')
}

function handleClickScene(item:any,index:number){
  window?.playClick()
  currentStationId.value = item.stationId
  currentStationIndex.value = index
}

function handleCloseSceneSelection(){
  window?.playClick()
  showSceneSelectionModal.value = false
}

onMounted(() => {
  setCardDimensions();
  window.addEventListener('resize', setCardDimensions);
});

onUnmounted(() => {
  emit('onGetActionButtons', [])
  window.removeEventListener('resize', setCardDimensions);
  store.commit('viewData/setFlyReplayData', {
    ...store.state.viewData.flyReplayData,
    enterPageMode: 1,
  })
});

onBeforeMount(()=>{
  if(store.state.persistence.towerIdentify.sceneCategoryId){
    store.commit('persistence/setTowerIdentify', {
      sceneCategoryId:null,
      sceneTypeId:null,
      sceneInfo:null
    })
  }
  getPageData()
})



return (_ctx: any,_cache: any) => {
  const _component_vkm_carousel = _resolveComponent("vkm-carousel")!
  const _component_n_carousel_item = _resolveComponent("n-carousel-item")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_vkn_button = _resolveComponent("vkn-button")!
  const _component_vkm_modal = _resolveComponent("vkm-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "card-list-container",
      style: _normalizeStyle(cardBoxStyle.value)
    }, [
      _createVNode(_component_vkm_carousel, {
        cardsList: cardsList.value,
        useControls: false,
        onOnClick: handleClick,
        isShowLock: true,
        isUseFade: false
      }, null, 8, ["cardsList"])
    ], 4),
    (cardsList.value.length > 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "uav-container",
          style: _normalizeStyle(cardStyle.value)
        }, [
          (currentUavData.value?.modelPictureUrl)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("img", {
                        class: "uav-img",
                        src: currentUavData.value?.modelPictureUrl?_unref($config).FILE_ROOT_PATH+currentUavData.value?.modelPictureUrl:'',
                        alt: ""
                      }, null, 8, _hoisted_6)
                    ])
                  ])
                ]),
                _createElementVNode("p", _hoisted_7, _toDisplayString(currentUavData.value?.sceneUavType), 1),
                _createElementVNode("div", {
                  class: "switch-btn",
                  onClick: handleClickSwitch
                }, _cache[1] || (_cache[1] = [
                  _createElementVNode("span", null, "切换机型", -1)
                ]))
              ]))
            : _createCommentVNode("", true),
          (currentStatsionData.value?.scenePictureUrl && courseTypeId.value == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "carousel-img-container" }, null, -1)),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("img", {
                              class: "scene-img",
                              src: `${_unref($config).FILE_ROOT_PATH}${currentStatsionData.value?.scenePictureUrl}`,
                              alt: ""
                            }, null, 8, _hoisted_15),
                            (currentStatsionData.value.resourceType == 1)
                              ? (_openBlock(), _createElementBlock("img", _hoisted_16))
                              : (currentStatsionData.value.resourceType == 2)
                                ? (_openBlock(), _createElementBlock("img", _hoisted_17))
                                : (currentStatsionData.value.resourceType == 3)
                                  ? (_openBlock(), _createElementBlock("img", _hoisted_18))
                                  : (currentStatsionData.value.resourceType == 9)
                                    ? (_openBlock(), _createElementBlock("img", _hoisted_19))
                                    : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("p", _hoisted_21, _toDisplayString(currentStatsionData.value?.stationName), 1),
                  _createElementVNode("div", {
                    class: "switch-btn",
                    onClick: handleSwitchScene
                  }, _cache[3] || (_cache[3] = [
                    _createElementVNode("span", null, "切换场景", -1)
                  ]))
                ])
              ]))
            : _createCommentVNode("", true),
          (currentUavData.value?.modelPictureUrl && courseTypeId.value == 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("p", _hoisted_26, [
                        _createTextVNode(_toDisplayString(currentUavData.value?.maxSpeed?currentUavData.value?.maxSpeed:''), 1),
                        _createElementVNode("span", null, _toDisplayString(currentUavData.value?.maxSpeed?'m/s':''), 1)
                      ]),
                      _cache[4] || (_cache[4] = _createElementVNode("p", { class: "title" }, "最大速度", -1))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("p", _hoisted_30, [
                        _createTextVNode(_toDisplayString(currentUavData.value?.flyTime?currentUavData.value?.flyTime:''), 1),
                        _createElementVNode("span", null, _toDisplayString(currentUavData.value?.flyTime?'min':''), 1)
                      ]),
                      _cache[5] || (_cache[5] = _createElementVNode("p", { class: "title" }, "最大续航", -1))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "content" }, null, -1)),
                    (modelList.value.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                          _createElementVNode("div", _hoisted_34, [
                            _createVNode(_unref(NCarousel), {
                              "current-index": currentModelIndex.value,
                              loop: false,
                              "show-dots": false,
                              "show-arrow": true,
                              onUpdateCurrentIndex: handleUpdatScene
                            }, {
                              arrow: _withCtx(({ prev, next }) => [
                                _createElementVNode("div", {
                                  id: currentModelIndex.value == 0?'disabled-switch':'',
                                  class: "switch-btn prev-switch-btn"
                                }, [
                                  _createElementVNode("i", {
                                    class: "iconfont-fill vk_bf_fill",
                                    onClick: ($event: any) => (handleSwitchModel('prev',prev))
                                  }, null, 8, _hoisted_39)
                                ], 8, _hoisted_38),
                                _createElementVNode("div", {
                                  id: currentModelIndex.value == modelList.value.length - 1?'disabled-switch':'',
                                  class: "switch-btn next-switch-btn"
                                }, [
                                  _createElementVNode("i", {
                                    class: "iconfont-fill vk_bf_fill",
                                    onClick: ($event: any) => (handleSwitchModel('next',next))
                                  }, null, 8, _hoisted_41)
                                ], 8, _hoisted_40)
                              ]),
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modelList.value, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_n_carousel_item, { key: index }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_35, [
                                        _createElementVNode("img", {
                                          src: item?.icon,
                                          class: "icon",
                                          alt: ""
                                        }, null, 8, _hoisted_36),
                                        _createElementVNode("span", _hoisted_37, _toDisplayString(item?.name), 1)
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["current-index"])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ], 4))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_vkm_modal, {
      title: "选择机型",
      onOnClose: handleClose
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_42, [
          _createVNode(_component_el_scrollbar, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_43, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uavDataList.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(currentUavId.value == item.id?'card-item uav-active':'card-item'),
                    key: index,
                    onClick: ($event: any) => (handleClickUav(item.id))
                  }, [
                    _createElementVNode("div", _hoisted_45, [
                      _createElementVNode("img", {
                        src: _unref($config).FILE_ROOT_PATH+item.modelPictureUrl
                      }, null, 8, _hoisted_46)
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("p", null, _toDisplayString(item?.sceneUavType), 1)
                    ])
                  ], 10, _hoisted_44))
                }), 128))
              ])
            ]),
            _: 1
          })
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_48, [
          _createVNode(_component_vkn_button, {
            label: "取消",
            type: "info",
            size: "medium",
            onClick: handleCancle
          }),
          _createVNode(_component_vkn_button, {
            label: "确定",
            type: "primary",
            size: "medium",
            onClick: handleConfirm,
            loading: confirmLoading.value
          }, null, 8, ["loading"])
        ])
      ]),
      _: 1
    }, 512), [
      [_vShow, showModel.value]
    ]),
    _withDirectives(_createVNode(_component_vkm_modal, {
      title: "选择场地",
      onOnClose: handleCloseSceneSelection,
      class: "scene-selection-modal"
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_49, [
          _createVNode(_component_el_scrollbar, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_50, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stationDataList.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass([currentStationIndex.value == index?'active-scene-item':'','scene-item']),
                    key: index,
                    onClick: ($event: any) => (handleClickScene(item,index))
                  }, [
                    _createElementVNode("img", {
                      class: "scene-img",
                      src: `${_unref($config).FILE_ROOT_PATH}${item.scenePictureUrl}`,
                      alt: ""
                    }, null, 8, _hoisted_52),
                    (item.resourceType == 1)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_53))
                      : (item.resourceType == 2)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_54))
                        : (item.resourceType == 3)
                          ? (_openBlock(), _createElementBlock("img", _hoisted_55))
                          : (item.resourceType == 9)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_56))
                            : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("span", null, _toDisplayString(item.stationName), 1)
                    ])
                  ], 10, _hoisted_51))
                }), 128))
              ])
            ]),
            _: 1
          })
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_58, [
          _createVNode(_component_vkn_button, {
            label: "取消",
            type: "info",
            size: "medium",
            onClick: _cache[0] || (_cache[0] = ()=>{showSceneSelectionModal.value = false;})
          }),
          _createVNode(_component_vkn_button, {
            label: "保存",
            type: "primary",
            size: "medium",
            onClick: handleConfirmScene,
            loading: confirmLoading.value
          }, null, 8, ["loading"])
        ])
      ]),
      _: 1
    }, 512), [
      [_vShow, showSceneSelectionModal.value]
    ]),
    (props.showStudyPlanModal)
      ? (_openBlock(), _createBlock(_component_vkm_modal, {
          key: 1,
          class: "plan-modal",
          title: "学习计划",
          onOnClose: handleCloseStudy
        }, {
          content: _withCtx(() => [
            _createVNode(StudyPlan, { statisticData: currentStatsionData.value }, null, 8, ["statisticData"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})